import { SVGS } from '@/assets/svgs'
import { useBrowserQuery } from '@/hooks/common'
import useAppStore from '@/store/useAppStore'
import colors from '@/styles/colors'
import { ArrowBackIos } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { shallow } from 'zustand/shallow'
import { useLocation, useNavigate } from 'react-router-dom'
import { ShareLink } from '@/components/ShareLink'

interface Props {
  trackKey: string
}

export default function NoteShares({ trackKey }: Props) {
  const [isViewMode, setIsViewMode] = useState(false)
  const query = useBrowserQuery()
  const topicID = query.get(trackKey) || ''
  const noteID = query.get('noteID') || ''

  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [topicSelectedAt] = useAppStore((state) => [state.home.topicSelectedAt], shallow)

  useEffect(() => {
    if (noteID) {
      setIsViewMode(false)
    }
  }, [noteID, topicSelectedAt])

  const handleBack = () => {
    query.delete('noteID')
    query.delete('step')
    navigate(`${pathname}?${query.toString()}`, { replace: true })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        height: '100%',
        padding: '16px',
        position: 'relative',
        gap: '16px',
      }}
    >
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        <IconButton
          onClick={handleBack}
          sx={{
            backgroundColor: 'transparent',
            px: 0,
          }}
        >
          <ArrowBackIos sx={{ ml: '8px', color: colors.backArrowColor }} />
        </IconButton>

        <Typography fontSize={'20px'} fontWeight={700} color={colors.themeBlack}>
          Share
        </Typography>
      </Box>

      <Box>
        <ShareLink onClose={() => {}} disableClose />
      </Box>
    </Box>
  )
}
